import { Password } from "primereact/password";
import {
  createAsyncThunk,
  createSlice,
  nanoid,
  PayloadAction,
} from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
import { useActionData } from "react-router-dom";
import { GetFileByEntityId } from "../../services/MediumService";
import { GetNoticesPaged } from "../../services/NoticeService";
import { log } from "@grpc/grpc-js/build/src/logging";

const initialState = {
  notifications: [] as any,
  status: "idle",
  error: "" as string | undefined,
};

export const fetchNotifications = createAsyncThunk(
  "/notifications/fetchNotifications",
  async (skip: number, thunkAPI) => {
    return;
    //const response = //await GetNoticesPaged(skip, 4);
    //return response.data;
  }
);

export const updateNotifications = createAsyncThunk(
  "/notifications/updateNotifications",
  async (data: any) => {
    return { response: data };
  }
);

const groupsSlice = createSlice({
  name: "groups",
  initialState: initialState,
  reducers: {
    groupAdded: (state, action: PayloadAction<any>) => {
      state.notifications.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(
        fetchNotifications.fulfilled,
        (state, action: PayloadAction<any>) => {
          action.payload.map((p: any) => state.notifications.push(p));
          state.status = "idle";
        }
      )
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "idle";
      })
      .addCase(updateNotifications.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateNotifications.fulfilled, (state, action) => {
        const updateGroupIndex = state.notifications.findIndex(
          (p: any) => p.id === action.payload.response.id
        );
        //console.log(updateGroupIndex);
        //console.log(action.payload.response);
        if (updateGroupIndex === -1) {
          state.notifications.push(action.payload.response);
        }
        state.status = "idle";
      })
      .addCase(updateNotifications.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "idle";
      });
  },
});

export const selectAllGroups = (state: any) => state.notices.notices;
export const { groupAdded } = groupsSlice.actions;

export default groupsSlice.reducer;
